// import axios from "axios";

// export const setupAxiosInterceptors = (logoutCallback) => {
//   axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//       if (error.response && error.response.status === 401) {
//         // Password changed or unauthorized
//         logoutCallback();
//       }
//       return Promise.reject(error);
//     }
//   );
// };


import axios from "axios";
import { getDeviceToken } from "./deviceToken";

export const setupAxiosInterceptors = (logoutCallback, setToken) => {
  const requestInterceptor = axios.interceptors.request.use((config) => {
    const deviceToken = getDeviceToken();
    config.headers = config.headers || {};
    if (deviceToken) {
      config.headers["X-Device-Token"] = deviceToken;
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const responseMessage = error.response?.data?.message || "";

      if (error.response?.status === 403 && /Unauthorized Device|blocked/i.test(responseMessage)) {
        logoutCallback();
        return Promise.reject(error);
      }

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API}/user/refresh_token`,
            {
              withCredentials: true,
              // Must send X-Device-Token on refresh — the session guard requires it.
              // Without this header, the guard returns 403 and triggers an auto-logout.
              headers: { "X-Device-Token": getDeviceToken() || "" },
            }
          );

          const newAccessToken = res.data.accesstoken;
          setToken(newAccessToken);

          originalRequest.headers["Authorization"] = newAccessToken;

          return axios(originalRequest);
        } catch (err) {
          logoutCallback();
        }
      }

      return Promise.reject(error);
    }
  );

  return () => {
    axios.interceptors.request.eject(requestInterceptor);
  };
};

